window.addEventListener('scroll', function() {
    // Announcement bar ka height get karte hain
    var announcementHeight = document.querySelector('.announcement-bar-section') ? document.querySelector('.announcement-bar-section').offsetHeight : 0;

    // Custom header ko get karte hain
    var header = document.querySelector('.custom-header-sec.shopify-section-header-sticky');

    if (header) {
        // Agar scroll past header ho gaya ho, toh CSS top property apply karte hain
        if (window.scrollY > announcementHeight) {
            header.classList.add('scrolled-past-header');  // Class add karte hain
            header.style.top = `${announcementHeight}px`;  // Top ko set karte hain
        } else {
            header.classList.remove('scrolled-past-header');  // Class remove karte hain
            header.style.top = '0';  // Top ko reset karte hain
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent;
  var platform = navigator.platform.toLowerCase();

  var isWindows = platform.includes('win');
  var isChrome = /chrome|crios/i.test(ua) && !/edge|edg|opr|opera/i.test(ua);
  var isSafari = /^((?!chrome|crios|android|edge|edg|opr|opera).)*safari/i.test(ua);

  // Windows par Chrome
  if (isChrome && isWindows) {
    document.body.classList.add('windows-chrome');
  }
  // Safari browser (macOS ya iOS)
  else if (isSafari) {
    document.body.classList.add('safari-body');
  }
  // Chrome on non-Windows platforms
  else if (isChrome) {
    document.body.classList.add('safari-chrome');
  }
});


// document.addEventListener('DOMContentLoaded', function() {
//   const prevButton = document.querySelector('.slider-button--prev');
//   const nextButton = document.querySelector('.slider-button--next');
//   const slides = document.querySelectorAll('.slider__slide');
//   const totalSlides = slides.length;
//   let currentIndex = 0;

//   // Function to update the slider state (active slide & button states)
//   function updateSlide() {
//     // Toggle the 'is-active' class on slides
//     slides.forEach((slide, index) => {
//       slide.classList.toggle('is-active', index === currentIndex);
//     });

//     // Update the current slide number
//     document.querySelector('.slider-counter--current').textContent = currentIndex + 1;

//     // Handle the visibility of Prev button
//     if (currentIndex === 0) {
//       prevButton.classList.add('disabled');
//       prevButton.setAttribute('disabled', 'true');
//       prevButton.style.display = 'none';  // Hide Prev button on first slide
//     } else {
//       prevButton.classList.remove('disabled');
//       prevButton.removeAttribute('disabled');
//       prevButton.style.display = 'inline-block';  // Show Prev button if not on first slide
//     }

//     // Handle the visibility of Next button
//     if (currentIndex === totalSlides - 1) {
//       nextButton.classList.add('disabled');
//       nextButton.setAttribute('disabled', 'true');
//       nextButton.style.display = 'none';  // Hide Next button on last slide
//     } else {
//       nextButton.classList.remove('disabled');
//       nextButton.removeAttribute('disabled');
//       nextButton.style.display = 'inline-block';  // Show Next button if not on last slide
//     }
//   }

//   // Event listener for 'Previous' button
//   prevButton.addEventListener('click', function() {
//     if (currentIndex > 0) {
//       currentIndex--;
//       updateSlide();
//     }
//   });

//   // Event listener for 'Next' button
//   nextButton.addEventListener('click', function() {
//     if (currentIndex < totalSlides - 1) {
//       currentIndex++;
//       updateSlide();
//     }
//   });

//   // Initialize the slider with the first slide
//   updateSlide();
// });
// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(function () {
//     var searchInputWrapper = document.querySelector('.header-search__input');
//     var details = document.querySelector('.details-modal details');

//     if (details) {
//       searchInputWrapper.addEventListener('mouseenter', function () {
//         details.classList.add('open');
//       });

//       searchInputWrapper.addEventListener('mouseleave', function () {
//         details.classList.remove('open');
//       });
//     } else {
//       console.log('No  element found inside');
//     }
//   }, 500); // Wait for 500ms (adjust if necessary)
// });

// Function to handle click event
// Function to handle click event for adding/removing class

document.addEventListener('DOMContentLoaded', function () {
    var swiperContainer = document.querySelector(".testimonial-sec .swiper-container");

    // Initialize Swiper instance
    var mySwiper = new Swiper(swiperContainer, {
       slidesPerView: 1,
       centeredSlides: true,
       loop: true,
       loopAdditionalSlides: 30,
       spaceBetween: 0,
       pagination: {
        el: '.slider__pagination',
        clickable: true,
      },
       
    });

  var swiperContainer = document.querySelector(".bodyarea-mobile .swiper-container");


      // Initialize Swiper instance
      var mySwiper = new Swiper(swiperContainer, {
         slidesPerView: 1.22,
        // slidesPerView: "auto",
        
        
        loop: false,
        loopAdditionalSlides: 30,
        spaceBetween: 20,
        breakpoints: {
    568: {
      slidesPerView: 1.22,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 2.22,
      spaceBetween: 20
    }
  }
      });

          var swiperContainer = document.querySelector(".contactus__right .swiper-container");

var mySwiper = new Swiper(swiperContainer, {
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true, 
  autoplay: {
    delay: 3000, // 3 seconds per slide
    disableOnInteraction: false // keeps autoplay even when user interacts
  },
  breakpoints: {
    568: {
      slidesPerView: 1,
      spaceBetween: 0
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 0
    }
  }
});

document.querySelector('.mobile-header__closeicon svg').addEventListener('click', function() {
    var body = document.querySelector('body');
    var menuDrawerContainer = document.querySelector('details.menu-drawer-container');
    var customHeaderSec = document.querySelector('.custom-header-sec');
    var headerIconMenu = document.querySelector('.header__icon--menu');
    
    body.classList.remove('overflow-hidden-tablet');
    menuDrawerContainer.classList.remove('menu-opening');
    menuDrawerContainer.removeAttribute('open');
    customHeaderSec.classList.remove('menu-open');
    headerIconMenu.removeAttribute('aria-expanded');
});


  
  });
// Featured collection slider End here 

const dropdownState = {
  listeners: { text: null, options: [] },
  observer: null,
  initialized: false
};

window.attachDropdownEvents = function() {
  const dropdownText = document.querySelector(".custom-dropdown-text");
  const dropdownOptions = document.querySelector(".custom-dropdown-options"); 
  const dropdownItems = document.querySelectorAll(".custom-dropdown-option");
  if (!dropdownText || !dropdownOptions || dropdownItems.length === 0) return;
  if (dropdownState.listeners.text) {
    dropdownText.removeEventListener("click", dropdownState.listeners.text);
  }
  dropdownState.listeners.options.forEach(({element, handler}) => {
    element.removeEventListener("click", handler);
  });
  dropdownState.listeners.options = [];
  const textClickHandler = (e) => {
    e.stopPropagation();
    dropdownOptions.classList.toggle("show");
  };
  dropdownText.addEventListener("click", textClickHandler);
  dropdownState.listeners.text = textClickHandler;

  dropdownItems.forEach(item => {
    const itemClickHandler = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const facetForm = item.closest('facet-filters-form');
      const sortingSelect = facetForm?.querySelector('.facet-filters__sort');
      const selectedValue = item.getAttribute('data-value');
      if (sortingSelect && selectedValue) {
        sortingSelect.value = selectedValue;
        sortingSelect.dispatchEvent(new Event('input', { bubbles: true }));
        const form = facetForm?.querySelector('form');
        if (form) {
          form.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      dropdownText.textContent = item.textContent;
      dropdownItems.forEach(opt => opt.classList.remove("selected"));
      item.classList.add("selected");
      dropdownOptions.classList.remove("show");
    };
    
    item.addEventListener("click", itemClickHandler);
    dropdownState.listeners.options.push({
      element: item,
      handler: itemClickHandler
    });
  });

  const initialValue = dropdownText.textContent.trim();
  dropdownItems.forEach(item => {
    if (item.textContent.trim() === initialValue) {
      item.classList.add("selected");
    }
  });

  const closeHandler = (e) => {
    if (!dropdownOptions.classList.contains("show")) return;
    if (!dropdownText.contains(e.target) && !dropdownOptions.contains(e.target)) {
      dropdownOptions.classList.remove("show");
    }
  };
  document.addEventListener("click", closeHandler, true);
  dropdownState.listeners.closeHandler = closeHandler;
};

function initializeDropdown() {
  if (dropdownState.initialized) return;
  window.attachDropdownEvents();
  dropdownState.observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const affectedNodes = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1 && (
            node.classList?.contains('custom-dropdown') ||
            node.querySelector('.custom-dropdown')
          );
        });
        
        if (affectedNodes) {
          window.attachDropdownEvents();
        }
      }
    });
  });

  if (document.body) {
    dropdownState.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  dropdownState.initialized = true;
}

if (document.readyState === 'complete') {
  initializeDropdown();
} else {
  document.addEventListener('DOMContentLoaded', initializeDropdown);
  window.addEventListener('load', initializeDropdown);
}

if (typeof Turbolinks !== 'undefined' && Turbolinks.supported) {
  document.addEventListener('turbolinks:load', initializeDropdown);
}

// window.changeSortOptionText = function () {
//   if (window.location.href.includes('?sort_by')){
//    let currentValue = document.querySelector('#SortBy').value, 
//     newValue = document.querySelector('#SortBy').querySelector(`option[value="${currentValue}"]`).innerHTML;
//     document.querySelector('.custom-dropdown-text').innerHTML = newValue;
//   }
//   urlParams = new URLSearchParams(window.location.search);
//   const currentSortValue = urlParams.get('sort_by');
//   const customSortFilterOptions = document.querySelectorAll('#customSortBy .custom-dropdown-option');
//     customSortFilterOptions.forEach(optionItem => {
//     const valueItem = optionItem.getAttribute('data-value');
//     if (currentSortValue == valueItem) {
//       const textContent = optionItem.innerHTML;
//       // document.querySelector('.custom-dropdown-text').innerHTML = textContent;
//     }
      
//   });
// }

// window.changeSortOptionText();

function selectSortOption () {
   const AllFilters = document.querySelectorAll('facet-filters-form');
  if(AllFilters.length > 0){
    AllFilters.forEach(filter => {
      const AllCustomFilters = filter?.querySelector('.sort-filter-custom')?.querySelector('.custom-dropdown-options')?.querySelectorAll('.custom-dropdown-option');
      if(AllCustomFilters && AllCustomFilters.length > 0){
        AllCustomFilters.forEach(div => {
          div.addEventListener('click', updateSortByFilter.bind(this));
        })
      }
    })
  } 
}

selectSortOption();

function updateSortByFilter(event) {
  const _this = event.target;
  const facetform = _this?.closest('facet-filters-form');
  const selected_value = _this?.getAttribute('data-value');
  const dropdownText = _this.closest('.sort-filter-custom').querySelector('.custom-dropdown-text');
  
  if (dropdownText) {
    dropdownText.textContent = _this.textContent.trim();
  }
  
  const SortingSelect = facetform?.querySelector('.facet-filters__sort');
  
  if(!SortingSelect) return;
  
  SortingSelect.value = selected_value;
  
  const inputEvent = new Event('input', {
    bubbles: true,
    cancelable: true
  });
  
  const form = facetform.querySelector('form');
  if(form) {
    SortingSelect.dispatchEvent(inputEvent);
    form.dispatchEvent(inputEvent);
  }
  
  const dropdownOptions = _this.closest('.custom-dropdown-options');
  if (dropdownOptions) {
    dropdownOptions.classList.remove('show');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
  if (!productInfo) return;

  const container =
    productInfo.querySelector('.custom-product-sec .swiper-container') ||
    productInfo.querySelector('.swiper-container');
  if (!container) return;

  const swiper = new Swiper(container, {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    loop: true,
    pagination: {
      el: container.querySelector('.slider__pagination'),
      clickable: true
    },
    navigation: {
      nextEl: container.querySelector('.swiper-button-next'),
      prevEl: container.querySelector('.swiper-button-prev')
    }
  });

  const getSelectedVariant = () => {
    const el = productInfo.querySelector('variant-selects script[data-selected-variant]');
    if (!el?.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const getRealSlides = () =>
    Array.from(
      container.querySelectorAll('.swiper-slide[data-media-id]:not(.swiper-slide-duplicate)')
    );

  const slideToVariantMedia = () => {
    const variant = getSelectedVariant();
    const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;

    const slides = getRealSlides();
    const realIndex = slides.findIndex(
      (s) => String(s.dataset.mediaId) === String(mediaId)
    );

    if (!mediaId || realIndex < 0) return;

    swiper.update();
    swiper.slideToLoop(realIndex, 0);
  };

  slideToVariantMedia();

  productInfo.addEventListener(
    'change',
    (e) => {
      const t = e.target;
      if (!t) return;

      if (t.matches('variant-selects input[type="radio"], variant-selects select')) {
        setTimeout(slideToVariantMedia, 0);
      }
    },
    true
  );

  const mo = new MutationObserver(() => {
    setTimeout(slideToVariantMedia, 0);
  });

  mo.observe(productInfo, {
    subtree: true,
    childList: true,
    characterData: true
  });
});

// slider on product page

document.addEventListener('DOMContentLoaded', function () {
  const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
  if (!productInfo) return;

  const container =
    productInfo.querySelector('.custom-product-sec .swiper-container') ||
    productInfo.querySelector('.swiper-container');
  if (!container) return;

  // Init swiper on the element
  const swiper = new Swiper(container, {
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    pagination: {
      el: container.querySelector('.slider__pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: container.querySelector('.swiper-button-next'),
      prevEl: container.querySelector('.swiper-button-prev'),
    },
  });

  const getSelectedVariant = () => {
    // IMPORTANT: query fresh every time (don’t cache variantSelects/script)
    const el = productInfo.querySelector('variant-selects script[data-selected-variant]');
    if (!el?.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[variant-media] Failed to parse selected variant JSON', e);
      return null;
    }
  };

  const getRealSlides = () =>
    Array.from(
      container.querySelectorAll('.swiper-slide[data-media-id]:not(.swiper-slide-duplicate)')
    );

  const slideToVariantMedia = () => {
    const variant = getSelectedVariant();
    const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;

    const slides = getRealSlides();
    const realIndex = slides.findIndex(
      (s) => String(s.dataset.mediaId) === String(mediaId)
    );

    // console.log('[variant-media]', { mediaId, realIndex, activeIndex: swiper.activeIndex });

    if (!mediaId || realIndex < 0) return;

    swiper.update();
    swiper.slideToLoop(realIndex, 0);
  };

  // Run once on load
  slideToVariantMedia();

  // Delegated listener: catches changes even if variant-selects gets replaced
  productInfo.addEventListener(
    'change',
    (e) => {
      // Only react to option inputs/selects inside productInfo
      const t = e.target;
      if (!t) return;

      // radio / select changes for variants
      if (t.matches('variant-selects input[type="radio"], variant-selects select')) {
        // Let Shopify update the selected-variant script first
        setTimeout(slideToVariantMedia, 0);
      }
    },
    true // capture helps when some components stop propagation
  );

  // MutationObserver: if Shopify updates the script node without a change event you catch
  const mo = new MutationObserver(() => {
    // This will fire when the script text changes OR nodes are swapped
    setTimeout(slideToVariantMedia, 0);
  });

  mo.observe(productInfo, {
    subtree: true,
    childList: true,
    characterData: true,
  });
});


